var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lose"},[_c('img',{attrs:{"src":require("../../assets/images/notfind.png"),"alt":""}}),_c('p',[_vm._v("哎呀，找不到页面了")]),_c('p',{staticClass:"mar-top"},[_vm._v("不要伤心，可能地址错了呢")])])
}]

export { render, staticRenderFns }